import React, { useState, useRef, useEffect } from "react";
import styles from "./ServiceOccurenceMediasTab.module.css";
import i18n from "../../Services/i18n";
import listIcon from "../../Assets/Icons/list.png";
import gridIcon from "../../Assets/Icons/grid.png";
import FileFolderPreview from "../FileFolderPreview/FileFolderPreview";
import FileUploaderModal from "../FileUploaderModal/FileUploaderModal";
import ServiceOccurenceService from "../../Services/serviceOccurenceService";

const ServiceOccurenceMediasTab = ({ service, reloadDetail }) => {
  const [viewMode, setViewMode] = useState("grid"); // 'list' or 'grid'
  const fileUploadModal = useRef();

  useEffect(() => {}, [service]);

  return (
    <>
      <FileUploaderModal
        ref={fileUploadModal}
        callback={async (thumbnail, fileId) => {
          await ServiceOccurenceService.AddMedia(fileId, service.externalId);
          reloadDetail(service.externalId);
          fileUploadModal.current.close();
        }}
        allowMultipleFiles={false}
      />
      <div className={styles.fileFolderPreview}>
        <div className={styles.sectionHeader}>
          <div className={styles.toolbar}>
            <button
              className={styles.headerButton}
              onClick={async () => {
                fileUploadModal.current.open();
              }}>
              {i18n.t("Generic.AddMedia")}
            </button>

            <img
              src={listIcon}
              alt="List View"
              className={`${styles.viewModeButton} ${
                viewMode === "list" ? styles.viewModeSelected : ""
              }`}
              onClick={() => setViewMode("list")}
            />
            <img
              src={gridIcon}
              alt="Grid View"
              className={`${styles.viewModeButton} ${
                viewMode === "grid" ? styles.viewModeSelected : ""
              }`}
              onClick={() => setViewMode("grid")}
            />
          </div>
        </div>

        <div className={styles.fileFolderPreviewContainer}>
          <FileFolderPreview
            files={service?.medias ?? []}
            viewMode={viewMode}
            onFileSelected={() => {}}
            smallIcon={false}
            refresh={() => reloadDetail(service.externalId)}
          />
        </div>
      </div>
    </>
  );
};

export default ServiceOccurenceMediasTab;
